<div class="auth-wrapper" *ngIf="mostrarForm == true">

	<!-- Painel ilustrativo: fundo animado + card do ecossistema -->
	<div class="auth-illustration">
		<ul class="circles">
			<li><img src="assets/images/login-icons/email.svg" alt=""></li>
			<li><img src="assets/images/login-icons/sms.svg" alt=""></li>
			<li><img src="assets/images/login-icons/headset.svg" alt=""></li>
			<li><img src="assets/images/login-icons/phone.svg" alt=""></li>
			<li><img src="assets/images/login-icons/contact.svg" alt=""></li>
			<li><img src="assets/images/login-icons/chat.svg" alt=""></li>
			<li><img src="assets/images/login-icons/email.svg" alt=""></li>
			<li><img src="assets/images/login-icons/sms.svg" alt=""></li>
			<li><img src="assets/images/login-icons/phone.svg" alt=""></li>
			<li><img src="assets/images/login-icons/headset.svg" alt=""></li>
		</ul>

		<div class="info-block">
			<h2 class="info-title" [innerHTML]="'loginInfo.tituloDestaque' | translate"></h2>
			<p class="info-desc">{{ 'loginInfo.jornadaDescricao' | translate }}</p>
			<div class="info-cards">
				<div class="info-mini-card">
					<img src="assets/images/login-icons/crm.svg" alt="">
					<span>{{ 'loginInfo.item1' | translate }}</span>
				</div>
				<div class="info-mini-card">
					<img src="assets/images/login-icons/gateway.svg" alt="">
					<span>{{ 'loginInfo.item2' | translate }}</span>
				</div>
				<div class="info-mini-card">
					<img src="assets/images/login-icons/dashboard.svg" alt="">
					<span>{{ 'loginInfo.item3' | translate }}</span>
				</div>
				<div class="info-mini-card">
					<img src="assets/images/login-icons/channels.svg" alt="">
					<span>{{ 'loginInfo.item4' | translate }}</span>
				</div>
			</div>
		</div>
	</div>

	<!-- Painel do formulário -->
	<div class="auth-panel">
		<div class="auth-panel-header">
			<img class="brand-logo-sm" *ngIf="AppConfig.theme == 'light'" src="image/talklogomedium_{{logo}}.png" alt="Logo">
		</div>

		<div class="auth-panel-body">
			<div class="auth-card">

				<!-- Logo para telas pequenas (quando a ilustração some) -->
				<div class="auth-mobile-logo">
					<img *ngIf="AppConfig.theme == 'light'" src="image/talklogomedium_{{logo}}.png" alt="Logo">
				</div>

				<!-- Passo 1: credenciais -->
				<form (submit)="realizarLogin()" *ngIf="!duploFator">
					<h2 class="auth-title">{{ 'login.bemVindo' | translate }}</h2>
					<p class="auth-subtitle">{{ 'login.continuarAcesso' | translate }}</p>

					<mat-form-field appearance="outline" [ngClass]="{'hashconta-preenchida' : hashContaPreenchida }">
						<mat-label>{{ 'login.contaId' | translate }}</mat-label>
						<input type="text" name="hashId" matInput placeholder="{{ 'login.contaId' | translate }}"
							[(ngModel)]="login.hashConta" [disabled]="hashContaPreenchida" required
							#contaModel="ngModel">
						<mat-icon mat-list-avatar class="icon-label" *ngIf="hashContaPreenchida"
							(click)="limparHashConta()">
							close
						</mat-icon>
					</mat-form-field>
					<div class="error-message" *ngIf="contaModel.invalid && contaModel.touched">
						<mat-icon class="error-icon">error_outline</mat-icon>
						<span class="text-danger">{{ 'validacao.contaObrigatorio' | translate }}</span>
					</div>

					<mat-form-field appearance="outline">
						<mat-label>{{ 'login.email' | translate }}</mat-label>
						<input type="email" name="email" id="email-input" matInput
							placeholder="{{ 'login.email' | translate }}" [(ngModel)]="login.login" required email
							#usuarioModel="ngModel">
					</mat-form-field>

					<div class="error-message"
						*ngIf="usuarioModel.invalid && usuarioModel.touched">
						<mat-icon class="error-icon">error_outline</mat-icon>
						<span class="text-danger" *ngIf="usuarioModel.errors?.['required']">{{
							'validacao.emailObrigatorio' | translate }}</span>
						<span class="text-danger" *ngIf="usuarioModel.errors?.['email']">{{
							'validacao.emailInvalido' | translate }}</span>
					</div>

					<mat-form-field appearance="outline">
						<mat-label>{{ 'login.senha' | translate }}</mat-label>
						<input type="password" name="senha" autocomplete="off" autocomplete="new-password"
							#InputSenha matInput placeholder="{{ 'login.senha' | translate }}" [(ngModel)]="login.senha"
							required #senhaModel="ngModel">
						<button mat-icon-button matSuffix type="button" (click)="mostrarSenha(InputSenha)">
							<mat-icon *ngIf="InputSenha.type == 'password'">visibility_off</mat-icon>
							<mat-icon *ngIf="InputSenha.type == 'text'">visibility</mat-icon>
						</button>
					</mat-form-field>
					<div class="error-message" *ngIf="senhaModel.invalid && senhaModel.touched">
						<mat-icon class="error-icon">error_outline</mat-icon>
						<span class="text-danger">{{ 'validacao.senhaObrigatorio' | translate }}</span>
					</div>

					<div class="forgot-link-row">
						<a class="auth-link" (click)="recuperarSenha()">{{ 'login.esqueciMinhaSenha' | translate }}</a>
					</div>

					<button type="submit" mat-raised-button color="primary" class="auth-submit"
						[disabled]="!login.hashConta || !login.login || !login.senha">
						{{ 'login.entrar' | translate }}
					</button>

					<div class="sso-buttons" *ngFor="let item of configSSO.ssoCorporativo">
						<button type="button" id="btn-aut" class="bg-success text-white" mat-raised-button
							(click)="loginSSO(item.codigo)">
							{{ item.descricao }}
						</button>
					</div>
				</form>

				<!-- Passo 2: dupla autenticação -->
				<div id="Login-Passo2" *ngIf="duploFator">
					<div class="mt-4 text-center">
						<img src="assets/images/cadeado.png" alt="Login" width="180px">
					</div>
					<div class="mt-4">
						<div class="text-center"
							*ngIf="timeLeft != '00:00' && loginConfirmacao.duplaAutenticacaoTipo == 2">
							{{'login.msgCodigoEnviado' | translate:{value: loginConfirmacao.digitosDuplaAutenticacao} }}
							<label>{{loginConfirmacao.email}}</label>
						</div>
						<div class="text-center" *ngIf="loginConfirmacao.duplaAutenticacaoTipo == 6">
							{{'login.codigoAPPAutenticador' | translate }}
						</div>
						<div class="mb-3 text-center"
							*ngIf="(timeLeft != '00:00' && loginConfirmacao.duplaAutenticacaoTipo == 2) || loginConfirmacao.duplaAutenticacaoTipo == 6">
							<label *ngIf="(timeLeft != '00:00' && loginConfirmacao.duplaAutenticacaoTipo == 2)">{{
								'login.msgExpiracaoCodigo' | translate }} <b>{{timeLeft}}</b>.</label>
							<br><br>
							<app-otp-input #otpInput [(ngModel)]="login.codigo"
								[size]="loginConfirmacao.digitosDuplaAutenticacao" (ngModelChange)="onOtpChange($event)"
								[hidden]="false"></app-otp-input>
							<br><br>
							<span class="error-msg" *ngIf="CodigoInvalido">
								{{ 'login.msgCodigoInvalido' | translate }}
							</span>
						</div>
						<div class="mb-3 text-center"
							*ngIf="timeLeft == '00:00' && loginConfirmacao.duplaAutenticacaoTipo == 2">
							<br>
							{{'login.msgReenviarCodigo1' | translate }} {{loginConfirmacao.email}}?<br>{{
							'login.msgReenviarCodigo2' | translate}} <a [routerLink]="" class="auth-link"
								(click)="ReenviarCodigo(2)" *ngIf="timeLeft == '00:00'">{{ 'login.msgReenviarCodigo3' |
								translate }}</a>
						</div>
					</div>
					<div class="mt-2 text-center"
						*ngIf="timeLeft != '00:00' && this.loginConfirmacao.duplaAutenticacaoTipo == 2">
						{{ 'login.msgInsiraCodigo' | translate }}
					</div>
				</div>

			</div>
		</div>

		<!-- Rodapé: seletor de idioma (bandeiras lado a lado) -->
		<div class="auth-panel-footer" *ngIf="!duploFator">
			<div class="language-flags">
				<img *ngFor="let item of idiomas" src="{{item.bandeira}}" alt="{{ item.nome }}"
					title="{{ item.nome }}" height="20" width="30"
					[class.active]="item.codigo == idiomaSelecionado.codigo" (click)="setLanguage(item)">
			</div>
		</div>
	</div>
</div>
